<template>
  <div class="wrapper">
    <div class="search-crumb-head">
      <base-bread-crumb
        :currBreadCrumb="currBreadCrumb" 
        :isShowPortal="false"
      ></base-bread-crumb>
      <div class="tag-head">
        <!--<div-->
        <!--class="mr5 tag"-->
        <!--v-if="searchCondition[3].selectedValues.length > 0"-->
        <!--&gt;-->
        <!--<span class="tag-title">{{ $t("page.content.purchaseType") }}：</span-->
        <!--&gt;<span-->
        <!--class="tag-content ell"-->
        <!--:title="formatMoreList(searchCondition[3].selectedValues)"-->
        <!--&gt;<span-->
        <!--v-for="(item, index) in searchCondition[3].selectedValues"-->
        <!--:key="index"-->
        <!--&gt;-->
        <!--{{ item.label }}</span-->
        <!--&gt;</span-->
        <!--&gt;-->
        <!--<span class="close" @click="handleClose(1)">x</span>-->
        <!--</div>-->
        <div
          class="mr5 tag"
          v-if="searchCondition[0].selectedValues.length > 0"
        >
          <span class="tag-title">{{ $t("page.content.purchaseType") }}：</span
          ><span
            class="tag-content ell"
            :title="formatMoreList(searchCondition[0].selectedValues)"
            ><span
              v-for="(item, index) in searchCondition[0].selectedValues"
              :key="index"
            >
              {{ item.label }}</span
            ></span
          >
          <span class="close" @click="handleClose(1)">x</span>
        </div>
        <div class="mr5 tag" v-if="searchCondition[1].selectedValue">
          <span class="tag-title">{{ $t("page.content.publishTime") }}：</span
          ><span
            class="tag-content ell"
            :title="searchCondition[1].selectedLabel"
            ><span>{{ searchCondition[1].selectedLabel }}</span></span
          >
          <span class="close" @click="handleClose(2)">x</span>
        </div>
        <div class="mr5 tag" v-if="moreList.length > 0">
          <span class="tag-title"
            >{{ $t("page.content.materialClassify") }}：</span
          ><span class="tag-content ell" :title="formatMoreList(moreList)"
            ><span v-for="(item, index) in moreList" :key="index">
              {{ item.label }}</span
            ></span
          >
          <span class="close" @click="handleClose(3)">x</span>
        </div>
      </div>
    </div>
    <!-- 搜索条件 start -->
    <!--<div class="search-condition">-->
    <!--<div class="condition ccui-clearfix">-->
    <!--<div class="fl condition-left ml20 condition-type">-->
    <!--标题-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <div class="search-condition">
      <div class="condition ccui-clearfix">
        <div
          :class="[
            languagezh_cn ? 'condition-leftCn' : 'condition-leftEn',
            'ml20',
            'condition-type',
            'fl'
          ]"
        >
          <!--标题-->
          {{ $t("page.content.title") }}
        </div>
        <!--请输入标题-->
        <div class="search fl">
          <el-input
            class="search-input fl"
            v-model="titleName" 
            :placeholder="$t('page.content.pleaseEnterTheTitle')"
          ></el-input>
          <el-button
            type="text"
            class="search-btn fl"
            @click="init('titleSearch')"
            >{{ $t("page.content.search") }}</el-button
          >
        </div>
      </div>
      <div class="condition ccui-clearfix">
        <div
          :class="[
            languagezh_cn ? 'condition-leftCn' : 'condition-leftEn',
            'ml20',
            'condition-type',
            'fl'
          ]"
        >
          {{ searchCondition[3].type }}
        </div>
        <div class="condition-right dis-flex flex-1">
          <div class="btn-options">
            <el-button
              size="mini"
              v-for="(item, index) in searchCondition[3].options"
              :key="index"
              :type="isActive(searchCondition[3], item)"
              :disabled="item.isNotLogin === '1'"
              @click="handleChange(searchCondition[3], item)"
              >{{ item.label }}
              <i
                v-if="item.isNotLogin === '1'"
                class="el-icon-warning-outline notice-warning-outline"
              ></i
              ><span class="notice-warning-text">{{
                $t("page.content.onlySupplierLogin")
              }}</span>
              <slot />
            </el-button>
          </div>
        </div>
      </div>
      <template v-for="(item1, index1) in searchCondition">
        <div
          class="condition ccui-clearfix"
          :class="{ moreFold: item1.typeValue === '3' && moreFlag }"
          :key="index1"
          v-if="index1 != 3"
        >
          <div
            :class="[
              languagezh_cn
                ? 'condition-leftCn conditionCn'
                : searchCondition.length > 6
                ? 'condition-leftEn conditionEn'
                : 'condition-leftEn conditionCn',
              'ml20',
              'condition-type',
              'fl'
            ]"
          >
            {{ item1.type }}
          </div>
          <!--物资分类 start-->
          <div
            :class="[
              {
                'dis-flex': !isMultiSelect,
                chooseActive: isMultiSelect
              },
              'condition-right',
              'flex-1'
            ]"
            v-if="item1.typeValue === '3'"
          >
            <div class="flex-1">
              <template v-for="(item, index) in item1.options">
                <div :key="index" style="display: inline-block;">
                  <el-button
                    size="mini"
                    :type="
                      item1.selectedValue === item.value
                        ? 'table-top-active'
                        : 'table-top'
                    "
                    :class="[
                      {
                        'button-show': item.isShow /*多选 选中时的样式*/
                      },
                      'ellipsis'
                    ]"
                    @click="
                      isMultiSelect
                        ? clickMatBigClasses(item)
                        : handleChange(item1, item)
                    "
                    >{{ item.label }}
                    <slot />
                  </el-button>
                  <a @click="handleItemDel(item)"
                    ><b v-show="item.isShow"><i class="el-icon-close"></i></b
                  ></a>
                </div>
              </template>
            </div>
            <div
              v-if="item1.typeValue === '3' && !isMultiSelect"
              class="dis-flex"
            >
              <div>
                <el-button
                  size="mini"
                  icon="icon-ccui-add-sup"
                  @click="handleMultiSelect"
                  >{{ $t("page.content.multiSelect") }}</el-button
                >
              </div>
              <div>
                <el-button type="text" @click="moreBtn" style="color: #4A4A4A;">
                  <!--更多-->
                  {{ $t("page.content.MoreAndMore") }}
                  <i class="el-icon-arrow-down"></i>
                </el-button>
              </div>
            </div>
            <div style="text-align:center;" v-show="isMultiSelect">
              <el-button
                size="mini"
                type="primary"
                :disabled="moreList.length <= 0"
                @click="handleConfirm"
                >{{ $t("page.content.sure") }}</el-button
              >
              <el-button @click="handleCancel">{{
                $t("page.content.cancel")
              }}</el-button>
            </div>
          </div>
          <!--物资分类 end-->

          <!--其他搜索条件 start-->
          <div
            class="condition-right dis-flex isShow-position"
            :class="{
              dropDown:
                item1.typeValue == 1 && (thisIndex === dropFlag || thisIndex1),
              'flex-1Cn': languagezh_cn,
              'flex-1En': !languagezh_cn
            }"
            ref="mySetHeightElement"
            v-else
          >
            <div
              class="btn-options"
              v-for="(item, index) in item1.options"
              :key="index"
            >
              <div v-if="item.value != 13 && item.value != 14">
                <div
                  :class="{
                    position_En:
                      !languagezh_cn && index == 5 && item.isNotLogin === '1'
                  }"
                >
                  <el-button
                    size="mini"
                    :type="isActive(item1, item)"
                    :disabled="item.isNotLogin === '1'"
                    @click="handleChange(item1, item, '')"
                    >{{ item.label }}
                    <i
                      v-if="item.isNotLogin === '1'"
                      class="el-icon-warning-outline notice-warning-outline"
                    ></i
                    ><span class="notice-warning-text">{{
                      $t("page.content.onlySupplierLogin")
                    }}</span>
                    <slot />
                  </el-button>
                </div>
              </div>

              <div v-else-if="item.value == 13">
                <div class="drop-btn">
                  <el-button
                    size="mini"
                    :type="isActive(item1, item)"
                    :style="{
                      color: `${thisIndex === index ? '#0089EF' : ''}`,
                      fontWeight: `${thisIndex === index ? 600 : ''}`
                    }"
                    :disabled="item.isNotLogin === '1'"
                    @click="dropDownHandle(item1, item)"
                    >{{ item.label }}
                    <i
                      v-if="item.isNotLogin === '1'"
                      class="el-icon-warning-outline notice-warning-outline"
                    ></i
                    ><span class="notice-warning-text">{{
                      $t("page.content.onlySupplierLogin")
                    }}</span>
                    <slot />
                  </el-button>
                  <i
                    class="el-icon-arrow-down"
                    ref="arrowClick"
                    @click="dropHandleChange(item1, item, index)"
                  ></i>
                </div>
                <div
                  class="dropContent"
                  v-show="thisIndex === index && gkDrop"
                  ref="mySetPositionElement1"
                >
                  <div :key="indexs" v-for="(items, indexs) in item.options">
                    <el-button
                      v-if="indexs == 0"
                      size="mini"
                      :class="{
                        dropAll: dropAllFlag,
                        dropAllNull: !dropAllFlag
                      }"
                      @click="handleChange(item1, items, 'dropT')"
                      >{{ items.label }}</el-button
                    >
                    <el-button
                      v-else
                      size="mini"
                      :type="isActive(item1, items)"
                      :class="{ dropAll: thisIndex === indexs }"
                      @click="handleChange(item1, items)"
                      >{{ items.label }}</el-button
                    >
                  </div>
                </div>
              </div>

              <div v-else-if="item.value == 14">
                <div class="drop-btn">
                  <el-button
                    size="mini"
                    :type="isActive(item1, item)"
                    :disabled="item.isNotLogin === '1'"
                    @click="dropDownHandle1(item1, item)"
                    >{{ item.label }}
                    <i
                      v-if="item.isNotLogin === '1'"
                      class="el-icon-warning-outline notice-warning-outline"
                    ></i
                    ><span class="notice-warning-text">{{
                      $t("page.content.onlySupplierLogin")
                    }}</span>
                    <slot />
                  </el-button>
                  <i
                    class="el-icon-arrow-down"
                    @click="dropHandleChange1(item1, item, index)"
                  ></i>
                </div>
                <div
                  class="dropContent"
                  v-show="thisIndex1"
                  ref="mySetPositionElement2"
                >
                  <div :key="indexs" v-for="(items, indexs) in item.options">
                    <el-button
                      v-if="indexs == 0"
                      size="mini"
                      :class="{
                        dropAll: dropAllFlag,
                        dropAllNull: !dropAllFlag
                      }"
                      @click="handleChange(item1, items, 'dropT')"
                      >{{ items.label }}</el-button
                    >
                    <el-button
                      v-else
                      size="mini"
                      :type="isActive(item1, items)"
                      @click="handleChange(item1, items)"
                      >{{ items.label }}</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--其他搜索条件 end-->
        </div>
      </template>
      <!--发布时间 start-->
      <div class="dis-flex" style="justify-content: space-between">
        <!--发布时间 start-->
        <a class="condition ccui-clearfix" @click="handleSortOrder">
          <div class="ml20 condition-type">
            {{ $t("page.content.publishTime") }}
          </div>
          <em>
            <i
              :class="{
                'el-icon-caret-top': true,
                active: sortOrder === '1',
                activeBlack: sortOrder !== '1'
              }"
            ></i>
            <i
              :class="{
                'el-icon-caret-bottom': true,
                active: sortOrder === '0',
                activeBlack: sortOrder !== '0'
              }"
            ></i>
          </em>
        </a>
        <!--发布时间 end-->

        <!--上面分页 start-->
        <div class="dis-flex condition-type" style="align-items: center">
          <span>{{ pageNo }}/{{ total }}</span>
          <em class="page-em">
            <el-link
              :underline="false"
              @click="handlePrev"
              :disabled="pageNo === 1"
              ><i class="icon-ccui-previous pr-5"></i
            ></el-link>
            <el-link
              :underline="false"
              @click="handleNext"
              :disabled="pageNo >= total"
              ><i class="icon-ccui-next"></i
            ></el-link>
          </em>
        </div>
        <!--上面分页  end-->
      </div>
      <!--发布时间 end-->
    </div>
    <!-- 搜索条件 end -->
    <!-- 内容 Begin -->
    <div
      class="notice-detail"
      style="padding:15px;padding-top:5px;background:#fff"
    >
      <el-table
        :data="pageData"
        header-cell-class-name="table_header"
        :border="true"
        :row-style="{ height: 0 }"
        style="width: 100%; margin-top: 20px"
        :empty-text="$t('page.content.noData')"
      >
        <!--序号-->
        <el-table-column :label="$t('page.content.serialNo')" :width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!--标题-->
        <el-table-column
          prop="noticeTitle"
          :label="$t('page.content.title')"
          :width="$TW.titleWidth"
        >
          <template slot-scope="{ row }">
            <a @click="handleView(row)">{{ row.noticeTitle }}</a>
          </template>
        </el-table-column>
        <!--类别-->
        <el-table-column
          prop="bigClassName"
          :label="$t('page.content.category')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="{ row }"
            ><span>{{ row.bigClassName.join(",") }}</span></template
          >
        </el-table-column>
        <!--采购方式-->
        <el-table-column
          prop="purchaseTypeName"
          :label="$t('page.content.purchaseType')"
        >
          <template slot-scope="{ row }"
            ><span>
              <!--108 公开单一来源  105 线下公开招标 109 线下公开询价  107 公开合作谈判 purchaseType == 8 && purchaseCategory == "4" 公开拍卖-->
              {{
                row.purchaseClass == "108"
                  ? $t("page.content.openSingleSource")
                  : row.purchaseClass == "105"
                  ? $t("page.content.openOfflineBidding")
                  : row.purchaseClass == "109"
                  ? $t("page.content.offlinePublicInquiry")
                  : row.purchaseClass == "107"
                  ? $t("page.content.openCollaboration")
                  : row.purchaseType == 8 && row.purchaseCategory == "4"
                  ? $t("page.content.publicAuction")
                  : row.purchaseType == "91"
                  ? $t("page.content.inquiry")
                  : row.purchaseType == "92"
                  ? $t("page.content.otherProcurement")
                  : row.purchaseType == "5"
                  ? $t("page.content.inviteBidd")
                  : row.purchaseType == "97"
                  ? $t("page.content.labelMenu10")
                  : row.purchaseType == "8"
                  ? $t("page.content.labelMenu11")
                  : row.purchaseType == "24"
                  ? $t("page.content.openCompetitiveNegotiation")
           
                  : row.purchaseType == "50"
                  ? $t("page.content.agreementType")
                  : row.purchaseType == "53"
                  ? $t("page.content.invitationType")
                  : row.purchaseType == "90"
                  ? $t("page.content.publicBidding")
                  : row.purchaseType == "93"
                  ? $t("page.content.invitationTender")
                  : row.purchaseType == "10"
                  ? $t("page.content.direct")
                  :""

              }}
              <!--        // : row.purchaseType == "4"
                  // ? $t("page.content.competitiveNegotiation") -->
              </span
            ></template
          >
        </el-table-column>
        <!--发布时间-->
        <el-table-column prop="packAmt" :label="$t('page.content.publishTime')">
          <template slot-scope="{ row }"
            ><span>{{
              moment(row.noticeStartTime).format("YYYY-MM-DD HH:mm")
            }}</span></template
          >
        </el-table-column>
        <!--报名截止时间-->
        <el-table-column
          prop="moneytypeStr"
          :label="$t('page.content.applicationDeadline')"
        >
          <template slot-scope="{ row }"
            ><span>{{
              row.firstRoundEndTime
                ? moment(row.firstRoundEndTime).format("YYYY-MM-DD HH:mm")
                : row.firstRoundEndTime
            }}</span></template
          >
        </el-table-column>
      </el-table>
      <!--<div-->
      <!--class="notice-detail-list mt15 ccui-clearfix"-->
      <!--v-if="pageData.length !== 0"-->
      <!--&gt;-->
      <!--<template v-for="(item, index) in pageData">-->
      <!--<div-->
      <!--:class="-->
      <!--`notice-detail-box mb20 fl ${(index + 1) % 5 !== 0 && 'mr20'}`-->
      <!--"-->
      <!--style="height: 320px"-->
      <!--:key="index"-->
      <!--&gt;-->
      <!--<div class="notice-detail-box-out" @click="handleView(item)">-->
      <!--<notice-item-block-->
      <!--:data="item"-->
      <!--source="search"-->
      <!--&gt;</notice-item-block>-->
      <!--</div>-->
      <!--<notice-item-bottom-btn :item="item"></notice-item-bottom-btn>-->
      <!--</div>-->
      <!--</template>-->
      <!--</div>-->
      <!--<div class="notice-detail-list mt15 ccui-clearfix " v-else>-->
      <!--<template>-->
      <!--<div class="notice-detail-box mb20 fl " style="height: 320px">-->
      <!--<div class="empty-content">-->
      <!--{{ $t("page.content.blockNoData") }}-->
      <!--</div>-->
      <!--</div>-->
      <!--</template>-->
      <!--</div>-->
    </div>
    <!-- 内容 End -->

    <!--分页Begin-->
    <div
      class="ccui-multifunctional-table-wrapper"
      style="background:#fff;padding-top:15px;padding-right:15px"
    >
      <div class="ccui-table-footer" v-show="pageData.length > 0">
        <div class="ccui-operation">
          <slot name="batchOp"></slot>
        </div>

        <div id="ccui-paging" :class="{ paginationEn: !languagezh_cn }">
          <el-pagination
            :total="pageTotal"
            :page-size="pageSize"
            :current-page="pageNo"
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
          <el-button
            class="ccui-pagination-btn"
            size="mini"
            type="default"
            @click="handleSizeChange('none')"
            >{{ $t("page.content.sure") }}</el-button
          >
        </div>
      </div>
    </div>
    <!--分页End-->
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import {
  qryMatcateryTreeList,
  searchSupBidNotice
} from "@/app/shop/api/shopping";
import { mixinHomePage } from "@/mixins/mixin-common/mixin-homePage";
// import noticeItemBlock from "@/app/shop/components/noticeItemBlock";
// import noticeItemBottomBtn from "@/app/shop/components/noticeItemBottomBtn";
import Cookies from "js-cookie";
import moment from "moment";
export default {
  name: "searchList",
  mixins: [mixinHomePage],
  components: {
    baseBreadCrumb
    // noticeItemBlock,
    // noticeItemBottomBtn
  },
  data() {
    return {
      moment,
      thisIndex: null,
      thisIndex1: false,
      gkDrop: false,
      moreFlag: true,
      dropAllFlag: false,
      //全部结果
      currBreadCrumb1: [{ title: this.$t("page.content.totalResult") }],
      currBreadCrumb: [],
      optionAll: [
        { label: this.$t("page.content.all"), value: "" },
        { label: this.$t("page.content.publicBidding"), value: "90" },
        {
          // 询价采购
          label: this.$t("page.content.inquiry"),
          value: "91",
          isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
        },
        // {
        //   //公开性竞争谈判
        //   label: this.$t("page.content.openCompetitiveNegotiations"),
        //   value: "24"
        // },
        // {
        //   // 竞争性谈判
        //   label: this.$t("page.content.competitiveNegotiation"),
        //   value: "3",
        //   isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
        // },
        {
          // 邀请招标
          label: this.$t("page.content.invitationTender"),
          value: "93",
          isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
        },
        {
          label: this.$t("page.content.direct"),
          value: "10",
          isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
        },
        // {
        //   // 邀请竞价
        //   label: this.$t("page.content.inviteBidd"),
        //   value: "5",
        //   isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
        // },
        {
          // 公开询价
          label: this.$t("page.content.publicInquiry"),
          value: "97"
        },
        // {
        //   // 公开竞价
        //   label: this.$t("page.content.publicOutcry"),
        //   value: "13",
        //   options: []
        // },
        // {
        //   // 其他采购
        //   label: this.$t("page.content.otherProcurement"),
        //   value: "14",
        //   options: []
        // }
      ],
      // 采购公告
      optionPublic: [
        { label: this.$t("page.content.all"), value: "" },
        { label: this.$t("page.content.publicBidding"), value: "90" },
        {
          label: this.$t("page.content.publicInquiry"),
          value: "97"
        },
        // {
        //   //公开竞争性谈判
        //   label: this.$t("page.content.openCompetitiveNegotiation"),
        //   value: "24"
        // },
        // {
        //   label: this.$t("page.content.publicOutcry"),
        //   value: "13",
        //   options: []
        // },
        // {
        //   // 其他采购
        //   label: this.$t("page.content.otherProcurement"),
        //   value: "14",
        //   options: []
        // }
      ],
      // 邀请公告
      optionInvite: [
        { label: this.$t("page.content.all"), value: "" },
        {
          label: this.$t("page.content.inquiry"),
          value: "91",
          isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
        },
        // {
        //   label: this.$t("page.content.competitiveNegotiation"),
        //   value: "3",
        //   isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
        // },
        {
          label: this.$t("page.content.invitationTender"),
          value: "93",
          isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
        },
        {
          label: this.$t("page.content.direct"),
          value: "10",
          isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
        },
        // {
        //   label: this.$t("page.content.inviteBidd"),
        //   value: "5",
        //   isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
        // }
      ],
      searchCondition: [
        {
          type: this.$t("page.content.purchaseType"),
          typeValue: "1",
          selectedValue: "",
          selectedLabel: this.$t("page.content.all"),
          selectedValues: [],
          options: [
            { label: this.$t("page.content.all"), value: "" },
            { label: this.$t("page.content.publicBidding"), value: "90" },
            {
              label: this.$t("page.content.inquiry"),
              value: "91",
              isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
            },
            // {
            //   //公开竞争性谈判
            //   label: this.$t("page.content.openCompetitiveNegotiation"),
            //   value: "24"
            // },
            // {
            //   label: this.$t("page.content.competitiveNegotiation"),
            //   value: "3",
            //   isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
            // },
            {
              label: this.$t("page.content.invitationTender"),
              value: "93",
              isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
            },
            {
              label: this.$t("page.content.direct"),
              value: "10",
              isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
            },
            // {
            //   label: this.$t("page.content.inviteBidd"),
            //   value: "5",
            //   isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
            // },
            {
              label: this.$t("page.content.publicInquiry"),
              value: "97"
            },
            // {
            //   label: this.$t("page.content.publicOutcry"),
            //   value: "13",
            //   options: []
            // },
            // {
            //   // 其他采购
            //   label: this.$t("page.content.otherProcurement"),
            //   value: "14",
            //   options: []
            // }
          ]
        },
        {
          type: this.$t("page.content.publishTime"),
          typeValue: "2",
          selectedValue: "",
          selectedLabel: this.$t("page.content.all"),
          options: [
            { label: this.$t("page.content.all"), value: "" },
            { label: this.$t("page.content.nearly3Days"), value: "93" },
            { label: this.$t("page.content.nearly7Days"), value: "97" },
            { label: this.$t("page.content.nearly30Days"), value: "30" }
          ]
        },
        {
          type: this.$t("page.content.materialClassify"),
          typeValue: "3",
          selectedValue: "",
          selectedLabel: this.$t("page.content.all"),
          options: []
        },
        {
          //类型
          type: this.$t("page.content.type"),
          typeValue: "4",
          selectedValue: "",
          selectedLabel: this.$t("page.content.all"),
          //采购公告  邀请公告
          options: [
            { label: this.$t("page.content.all"), value: "" },
            {
              label: this.$t("page.content.procurementAnnouncement"),
              value: 91
            },
            { label: this.$t("page.content.invitationAnnouncement"), value: 92 }
          ]
        }
      ],
      dropFlag: "",
      dropShow: "",
      wasteMaterialsType: "",
      // purchaseCategory: "",
      purchaseCate: 0,
      matBigClassesOptions: [{ label: this.$t("page.content.all"), value: "" }],
      pageData: [],
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0, //总条数
      total: 0, //总页数
      purchaseType: "", //采购方式
      noticeTime: [], //发布时间
      matBigClasses: this.$route.query.categoryCode, //物资分类
      sortOrder: "0", //排序
      isMultiSelect: false, //是否多选
      moreList: [],
      name: this.$route.query.name,
      titleName: "",
      categoryCode: this.$route.query.categoryCode || "",
      categoryName: this.$route.query.categoryName
        ? decodeURIComponent(this.$route.query.categoryName)
        : this.$t("page.content.all"),
      supInfo: this.$store.state.user.supInfo || {},
      otherProcure: false,
      searchParams: ""
    };
  },
  activated() {
    if (this.$route.query.type) {
      switch (this.$route.query.type) {
        case "98": //采购公告
          this.handleChange(
            this.searchCondition[3],
            this.searchCondition[3].options[1]
          );
          break;
        case "99": //邀请招标
          this.handleChange(
            this.searchCondition[3],
            this.searchCondition[3].options[2]
          );
          break;
        case "12": //废旧物资处理
          this.handleChange(
            this.searchCondition[3],
            this.searchCondition[3].options[1],
            "norequest"
          );
          this.handleChange(
            this.searchCondition[0],
            this.searchCondition[0].options[4],
            "norequest"
          );
          this.dropHandleChange(
            this.searchCondition[0],
            this.searchCondition[0].options[4],
            3,
            "norequest"
          );
          this.handleChange(
            this.searchCondition[0],
            this.searchCondition[0].options[4].options[2]
          );
          this.$nextTick(() => {});
          this.$refs.arrowClick[0].click();
          this.$nextTick(() => {
            this.$refs.arrowClick[0].click();
          });
          break;
        case "5": //询价采购
          this.searchCondition[0].selectedValues = [
            {
              value: "92",
              label: this.$t("page.content.inquiry")
            }
          ];
          break;
        case "6": //竞争谈判
          this.searchCondition[0].selectedValues = [
            // {
            //   value: "3",
            //   label: this.$t("page.content.competitiveNegotiation")
            // }
          ];
          break;
        case "9": //邀请竞价
          this.searchCondition[0].selectedValues = [
            // {
            //   value: "5",
            //   label: this.$t("page.content.inviteBidd")
            // }
          ];
          break;
        case "10": //公开询价
          this.searchCondition[0].selectedValues = [
            {
              value: "97",
              label: this.$t("page.content.publicInquiry")
            }
          ];
          break;
        case "11": //公开竞价
          // this.searchCondition[0].selectedValues = [
          //   {
          //     value: "8",
          //     label: this.$t("page.content.publicOutcry"),
          //     options: [
          //       { label: this.$t("page.content.all"), value: "" },
          //       {
          //         label: this.$t("page.content.publicOutcry"),
          //         value: "13"
          //       },
          //       {
          //         label: this.$t("page.content.wasteMaterials"),
          //         value: "12",
          //         purchaseCategory: "4"
          //       }
          //     ]
          //   }
          // ];
          break;
      }
    }

    // 物资分类 默认选中值
    if (this.categoryCode) {
      this.moreList = [
        {
          label: this.categoryName,
          value: this.categoryCode
        }
      ];
    }
    this.searchCondition[2].selectedValue = this.categoryCode;
    this.searchCondition[2].selectedLabel = this.categoryName;
    this.purchaseType = this.searchCondition[0].selectedValue;
    this.getMatcateryTreeList();
    console.log("init111");
    if (
      this.$route.query.type != 98 &&
      this.$route.query.type != 99 &&
      this.$route.query.type != 12
    ) {
      this.init("");
    }
  },
  deactivated() {
    this.moreList = [];
    this.searchCondition = [
      {
        type: this.$t("page.content.purchaseType"),
        typeValue: "1",
        selectedValue: "",
        selectedLabel: this.$t("page.content.all"),
        selectedValues: [],
        options: [
          { label: this.$t("page.content.all"), value: "" },
          { label: this.$t("page.content.publicBidding"), value: "90" },
          {
            label: this.$t("page.content.inquiry"),
            value: "91",
            isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
          },
          // {
          //   label: this.$t("page.content.competitiveNegotiation"),
          //   value: "3",
          //   isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
          // },
          {
            label: this.$t("page.content.invitationTender"),
            value: "93",
            isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
          },
          {
            label: this.$t("page.content.direct"),
            value: "10",
            isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
          },
          // {
          //   label: this.$t("page.content.inviteBidd"),
          //   value: "5",
          //   isNotLogin: this.$store.getters.getAccessToken ? "2" : "1"
          // },
          { label: this.$t("page.content.publicInquiry"), value: "97" },
          // {
          //   label: this.$t("page.content.publicOutcry"),
          //   value: "8",
          //   options: [
          //     {
          //       label: this.$t("page.content.all"),
          //       value: "",
          //       isJingjia: true
          //     },
          //     {
          //       label: this.$t("page.content.publicOutcry"),
          //       value: "13"
          //     },
          //     {
          //       label: this.$t("page.content.wasteMaterials"),
          //       value: "12",
          //       purchaseCategory: "4"
          //     }
          //   ]
          // }
        ]
      },
      {
        type: this.$t("page.content.publishTime"),
        typeValue: "2",
        selectedValue: "",
        selectedLabel: this.$t("page.content.all"),
        options: [
          { label: this.$t("page.content.all"), value: "" },
          { label: this.$t("page.content.nearly3Days"), value: "93" },
          { label: this.$t("page.content.nearly7Days"), value: "97" },
          { label: this.$t("page.content.nearly30Days"), value: "30" }
        ]
      },
      {
        type: this.$t("page.content.materialClassify"),
        typeValue: "3",
        selectedValue: "",
        selectedLabel: this.$t("page.content.all"),
        options: []
      }
    ];
    this.matBigClassesOptions = [];
    this.sortOrder = "0";
    this.isMultiSelect = false;
    this.matBigClasses = "";
    this.purchaseType = "";
    this.noticeTime = [];
  },
  mounted() {
    console.log("init");
  },
  methods: {
    init(type, item1) {
      console.log("init222");
      let supCodeList = [];
      if (this.supInfo.getSupInfoByLoginInfoRspBOList) {
        supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(item => {
          return item.supCode;
        });
      }
      this.currBreadCrumb = JSON.parse(JSON.stringify(this.currBreadCrumb1));
      if (this.name) {
        this.currBreadCrumb.push({ title: '"' + this.name + '"' });
      }
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        noticeTitle: this.titleName,
        schemeName: this.name,
        isShowPageLoading: true,
        sortName: "1",
        sortOrder: this.sortOrder,
        supCodeList: supCodeList,
        purchaseCategory: "",
        purchaseType: [],
        purchaseClassList: []
        // joinedOrNotJoin: true
      };
      if (
      'en-gb' !== undefined &&
       'en-gb' !== "zh-cn"
      ) {
        params.overseasSupFlag = 1;
      }
      if (this.dropAllFlag) {
        //公开竞价
        if (type && type.label == this.$t("page.content.publicOutcry"))
          params.purchaseType.push(8);
      }
      //类型
      if (
        this.purchaseCate &&
        item1 &&
        item1.type == this.$t("page.content.type")
      ) {
        this.purchaseCate == 1
          ? (params.purchaseType = [90,97])
          : this.purchaseCate == 2
          ? (params.purchaseType = [91, 93, 10])
          : (params.purchaseType = []);
      }
      //采购方式
      if (
        item1 &&
        item1.type == this.$t("page.content.purchaseType") &&
        !type.isJingjia &&
        !type.isQita
      ) {
        this.purchaseCate == 1
          ? (params.purchaseType = [90,97])
          : this.purchaseCate == 2
          ? (params.purchaseType = [91,93, 10])
          : (params.purchaseType = []);
      }
      //采购方式
      if (
        item1 &&
        item1.type == this.$t("page.content.purchaseType") &&
        type.isQita
      ) {
        if (this.purchaseCate == 1) {
          params.purchaseType.push(11);
        }
      }
      if (this.noticeTime && this.noticeTime.length !== 0) {
        //发布时间
        params.noticeTimeStart = this.noticeTime[0];
        params.noticeTimeEnd = this.noticeTime[1];
      }
      let matBigClassesParam = []; //物资分类
      if (this.moreList.length > 0) {
        matBigClassesParam = this.moreList.map(item => {
          return item.value;
        });
      } else {
        matBigClassesParam = [];
      }
      params.matBigClasses = matBigClassesParam; //物资分类(单选时)

      if (
        this.searchCondition[0].selectedValues &&
        this.searchCondition[0].selectedValues.length > 0
      ) {
        this.searchCondition[0].selectedValues.forEach(item => {
          if (item.value == "12") {
            params.purchaseCategory = "4";
            params.purchaseType.push("8");
          } else if (item.value == "13") {
            params.purchaseType.push("8");
          } else if (item.value == "8") {
            params.purchaseType.push("8");
            params.noPurchaseCategory = "4";
          } else if (
            item.value == "108" ||
            item.value == "105" ||
            item.value == "109" ||
            item.value == "107"
          ) {
            params.purchaseType.push("11");
            this.otherProcure = true;
            params.purchaseClassList.push(item.value);
          } else {
            if (
              item.value != "108" &&
              item.value != "105" &&
              item.value != "109" &&
              item.value != "107"
            ) {
              params.purchaseType.push(item.value);
            }
          }
        });
      } else {
        // 公开竞价
        if (type && type.value == "13") {
          params.purchaseType.push("8");
        }
        // 其他采购
        if (type && type.value == "14") {
          params.purchaseType.push("11");
        }
      }
      if (params.purchaseCategory == "4" && params.noPurchaseCategory == "4") {
        params.purchaseCategory = "";
        params.noPurchaseCategory = "";
      }
      let list = [],
        list2 = [];
      list = [...params.purchaseType];
      list.forEach((item, index) => {
        if (item == "12") {
          list.splice(index, 1, "8");
        }
        if (item == "14") {
          list.splice(index, 1, "11");
        }
      });
      console.log(this.searchCondition, "searchCondition");
      list2 = [...new Set(list)];
      params.purchaseType = [...list2];
      if (type == "titleSearch") {
        // params = this.searchParams;
        params = JSON.parse(sessionStorage.getItem("searchParams"));
        params.pageNo = 1;
        params.noticeTitle = this.titleName;
      } else {
        this.searchParams = params;
      }
      if (type == "pageclick") {
        params = JSON.parse(sessionStorage.getItem("searchParams"));
        params.pageNo = this.pageNo;
        params.pageSize = this.pageSize;
      }
      sessionStorage.setItem("searchParams", JSON.stringify(params));
      console.log(params, "searchSupBidNotice");
      searchSupBidNotice(params).then(res => {
        if (res.data.code === "0") {
          this.pageData = res.data.data.rows;
          this.pageData.forEach(item => {
            if (item.purchaseType == 8 && item.purchaseCategory == 4) {
              //废旧物资处置
              item.purchaseTypeName = this.$t("page.content.wasteMaterials");
            }
            if (item.purchaseType == 92) {
              item.firstRoundEndTime = item.noticeEndTime;
            }
          });
          this.pageTotal = res.data.data.recordsTotal;
          this.total = res.data.data.total;
        }
      });
    },
    getMatcateryTreeList() {
      //查询物资分类
      qryMatcateryTreeList({
        parentMatcateryCode: "00"
      }).then(res => {
        if (res.data.code === "0") {
          res.data.data.map(item => {
            this.matBigClassesOptions.push({
              label: item.matcateryName,
              value: item.matcateryCode
            });
            this.searchCondition[2].options = JSON.parse(
              JSON.stringify(this.matBigClassesOptions)
            );
          });
        }
      });
    },
    moreBtn() {
      this.moreFlag = !this.moreFlag;
    },
    dropHandleChange(item1, item, index, type) {
      if (!this.gkDrop) {
        this.thisIndex = null;
      }
      this.thisIndex1 = false;
      this.gkDrop = !this.gkDrop;
      const element = this.$refs.mySetHeightElement,
        element1 = this.$refs.mySetPositionElement1,
        len = this.searchCondition[0].options.length;
      if ( this.gkDrop && len > 6) {
        element[0].style.minHeight = "150px";
        element1[0].style.top = "80px";
      } else if (  this.gkDrop) {
        element[0].style.minHeight = "100px";
        element1[0].style.top = "30px";
      } else if (
       
        !this.gkDrop &&
        len > 6
      ) {
        element[0].style.minHeight = "100px";
        element1[0].style.top = "30px";
      } else if (!this.gkDrop) {
        element[0].style.minHeight = "50px";
        element1[0].style.top = "30px";
      }
      item1.selectedValue = item.value;
      item1.selectedLabel = item.label;
      let flag = true;
      item1.selectedValues.forEach(o => {
        if (o.value == 8 || o.value == 12) {
          flag = false;
        }
      });
      this.dropAllFlag = flag;
      if (item.value == 13) {
        item.options = [];
        let list = [
          // { label: this.$t("page.content.all"), value: "", isJingjia: true },
          // {
          //   label: this.$t("page.content.publicOutcry"),
          //   value: "8"
          // },
          // {
          //   // 废旧物资处置
          //   label: this.$t("page.content.wasteMaterials"),
          //   value: "12",
          //   purchaseCategory: "4"
          // }
        ];
        item.options.push(...list);
      } else if (item.value == 14) {
        item.options = [];
        let list = [
          { label: this.$t("page.content.all"), value: "", isQita: true },
          {
            // 公开单一来源
            label: this.$t("page.content.openSingleSource"),
            value: "108"
          },
          {
            // 线下公开招标
            label: this.$t("page.content.openOfflineBidding"),
            value: "105"
          },
          {
            // 线下公开询价
            label: this.$t("page.content.offlinePublicInquiry"),
            value: "109"
          },
          {
            // 公开合作谈判
            label: this.$t("page.content.openCollaboration"),
            value: "107"
          }
        ];
        item.options.push(...list);
      }
      this.thisIndex1 = false;
      if (this.thisIndex == null) {
        this.thisIndex = index;
        this.dropFlag = index;
        if (
          this.searchCondition[0].selectedValues &&
          this.searchCondition[0].selectedValues.length > 0
        ) {
          this.searchCondition[0].selectedValues.forEach((items, index) => {
            if (items.value == "13") {
              this.searchCondition[0].selectedValues.splice(index, 1);
            }
          });
        }
        if (type == "norequest") return;
        console.log("init333");
        this.init(item);
      } else {
        this.thisIndex = null;
      }

      // this.handleChange(item1, item)
      item1.selectedValues.push(item);
    },
    dropDownHandle(item1, item) {
      this.dropAllFlag = true;
      console.log(
        this.thisIndex,
        this.searchCondition[0].selectedValues,
        "searchCondition33"
      );
      if (this.thisIndex) {
        if (
          this.searchCondition[0].selectedValues &&
          this.searchCondition[0].selectedValues.length > 0
        ) {
          this.searchCondition[0].selectedValues.forEach((items, index) => {
            if (
              items.value == "12" ||
              items.value == "8" ||
              items.value == "13" ||
              items.value == ""
            ) {
              console.log(index, "searchCondition33");
              this.searchCondition[0].selectedValues.splice(index, 1);
              this.thisIndex = null;
            }
          });
        }
        // else {
        // if (item.value == '') {
        //   this.thisIndex = null;
        // }
        // }
        this.handleChange(item1, item);
      } else {
        this.handleChange(item1, item);
      }
    },
    dropHandleChange1(item1, item, index, type) {
      this.dropFlag = "";
      this.gkDrop = false;
      item1.selectedValue = item.value;
      item1.selectedLabel = item.label;
      let flag = true;
      item1.selectedValues.forEach(o => {
        if (
          o.value == 107 ||
          o.value == 108 ||
          o.value == 109 ||
          o.value == 105
        ) {
          flag = false;
        }
      });
      this.dropAllFlag = flag;
      if (item.value == 13) {
        item.options = [];
        let list = [
          // { label: this.$t("page.content.all"), value: "", isJingjia: true },
          // {
          //   label: this.$t("page.content.publicOutcry"),
          //   value: "8"
          // },
          // {
          //   // 废旧物资处置
          //   label: this.$t("page.content.wasteMaterials"),
          //   value: "12",
          //   purchaseCategory: "4"
          // }
        ];
        item.options.push(...list);
      } else if (item.value == 14) {
        item.options = [];
        let list = [
          { label: this.$t("page.content.all"), value: "", isQita: true },
          {
            // 公开单一来源
            label: this.$t("page.content.openSingleSource"),
            value: "108"
          },
          {
            // 线下公开招标
            label: this.$t("page.content.openOfflineBidding"),
            value: "105"
          },
          {
            // 线下公开询价
            label: this.$t("page.content.offlinePublicInquiry"),
            value: "109"
          },
          {
            // 公开合作谈判
            label: this.$t("page.content.openCollaboration"),
            value: "107"
          }
        ];
        item.options.push(...list);
      }
      this.thisIndex1 = !this.thisIndex1;
      const element = this.$refs.mySetHeightElement,
        element2 = this.$refs.mySetPositionElement2,
        len = this.searchCondition[0].options.length;
      if ( this.thisIndex1 && len > 6) {
        element[0].style.minHeight = "150px";
        element2[0].style.top = "80px";
      } else if ( this.thisIndex1) {
        element[0].style.minHeight = "100px";
        element2[0].style.top = "30px";
      } else if (
       
        !this.thisIndex1 &&
        len > 6
      ) {
        element[0].style.minHeight = "100px";
        element2[0].style.top = "30px";
      } else if (  !this.thisIndex1) {
        element[0].style.minHeight = "50px";
        element2[0].style.top = "30px";
      }

      if (this.thisIndex1) {
        if (
          this.searchCondition[0].selectedValues &&
          this.searchCondition[0].selectedValues.length > 0
        ) {
          this.searchCondition[0].selectedValues.forEach((items, index) => {
            if (items.value == "14") {
              this.searchCondition[0].selectedValues.splice(index, 1);
            }
          });
        }
        if (type == "norequest") return;
        console.log("init444");
        this.init(item);
      }
      item1.selectedValues.push(item);
    },
    dropDownHandle1(item1, item) {
      this.dropAllFlag = true;
      console.log(
        this.thisIndex,
        this.searchCondition[0].selectedValues,
        "searchCondition33"
      );
      if (this.thisIndex) {
        if (
          this.searchCondition[0].selectedValues &&
          this.searchCondition[0].selectedValues.length > 0
        ) {
          this.searchCondition[0].selectedValues.forEach((items, index) => {
            if (
              items.value == "12" ||
              items.value == "8" ||
              items.value == "13" ||
              items.value == ""
            ) {
              console.log(index, "searchCondition33");
              this.searchCondition[0].selectedValues.splice(index, 1);
              this.thisIndex = null;
            }
          });
        }
      } else {
        this.handleChange(item1, item);
      }
    },
    handleChange(item1, item, type) {
      let selectedArr = [
          { selectedName: "Open auction", selectedValue: "8" },
          { selectedName: "Other procurement methods", selectedValue: "12" },
          {
            selectedName: "Open single source procurement",
            selectedValue: "108"
          },
          { selectedName: "Offline open tendering", selectedValue: "105" },
          { selectedName: "Offline open quotation", selectedValue: "109" },
          { selectedName: "Open cooperative negotiation", selectedValue: "107" }
        ],
        flag = false;
      console.log(item.label);
      if (item.label == "All" && type != "dropT") flag = true;
      else
        flag = selectedArr.every(
          item1 =>
            item.label == item1.selectedName &&
            item.value != item1.selectedValue
        );
      if (flag) {
        const element = this.$refs.mySetHeightElement,
          len = this.searchCondition[0].options.length;
        if ( len > 6) {
          element[0].style.minHeight = "10px";
        } else if (
         
          (len < 6 || len == 6)
        ) {
          element[0].style.minHeight = "50px";
        }
      }

      if (item.isQita) {
        for (let i = item1.selectedValues.length - 1; i > -1; i--) {
          if (
            item1.selectedValues[i].value == 105 ||
            item1.selectedValues[i].value == 107 ||
            item1.selectedValues[i].value == 108 ||
            item1.selectedValues[i].value == 109
          ) {
            item1.selectedValues.splice(i, 1);
          }
        }
      }
      if (item.isJingjia) {
        for (let i = item1.selectedValues.length - 1; i > -1; i--) {
          if (
            item1.selectedValues[i].value == 8 ||
            item1.selectedValues[i].value == 12
          ) {
            item1.selectedValues.splice(i, 1);
          }
        }
      }
      if (type == "dropT") {
        this.dropAllFlag = true;
      } else {
        this.dropAllFlag = false;
      }
      console.log(this.thisIndex, item1, item, type);
      //类型
      if (item1.type == this.$t("page.content.type")) {
        if (item.value == 1 || item.value == 2 || item.value == "") {
          this.dropFlag = "";
          this.thisIndex = null;
          this.typeClose();
        }
      }
      //采购方式 全部
      if (item1.type == this.$t("page.content.purchaseType")) {
        if (type == "" && item.label == this.$t("page.content.all")) {
          this.dropFlag = "";
          this.thisIndex = null;
        }
      }
      if (item1.typeValue == 4) {
     
        if (item.value) {
          if (item.value == 91) {
            this.purchaseCate = 1;
          } else {
            this.purchaseCate = 2;
          }
        } else {
          this.purchaseCate = 3;
        }
      } else {
        if (!item.value) {
          this.purchaseCate = 1;
        } else {
          this.purchaseCate = 0;
        }
      }
      if (type == "dropT") {
        if (item.isJingjia) {
          if (this.searchCondition[3].selectedValue == 1) {
            item1.selectedValue = item1.options[3].value;
          } else {
            item1.selectedValue = item1.options[7].value;
          }
        } else {
          if (this.searchCondition[3].selectedValue == 1) {
            item1.selectedValue = item1.options[4].value;
          } else {
            item1.selectedValue = item1.options[8].value;
          }
        }
      } else {
        item1.selectedValue = item.value;
        item1.selectedLabel = item.label;
      }
      switch (item1.typeValue) {
        case "1": //采购方式
          if (item.value) {
            item1.selectedValue = "";
            let obj = item1.selectedValues.filter(i => {
              return i.value === item.value;
            });
            if (obj.length === 0) {
              item1.selectedValues.push({
                label: item.label,
                value: item.value
              });
            } else {
              let index = item1.selectedValues.indexOf(obj[0]);
              item1.selectedValues.splice(index, 1);
            }
          } else if (!item.isJingjia && !item.isQita) {
            item1.selectedValues = [];
          }
          this.purchaseType = item.value;
          break;
        case "2": //发布时间
          if (item.value === "") {
            this.noticeTime = [];
          } else {
            this.noticeTime = this.changeRecent(item.value);
          }
          break;
        case "3": //物资分类
          // this.matBigClasses = item.value;
          this.moreList = [];
          if (item.value) {
            this.moreList.push({
              label: item.label,
              value: item.value
            });
          }
          break;
        case "4": //类型
          // this.matBigClasses = item.value;
          if (item.value) {
            this.searchCondition[0].selectedValues=[]
            if (item.value == 91) {
              this.searchCondition[0].options = this.optionPublic;
            } else {
              this.searchCondition[0].options = this.optionInvite;
            }
          } else {
            this.searchCondition[0].options = this.optionAll;
          }
          break;
      }
      this.pageNo = 1;
      if (type == "norequest") return;
      console.log("init555");
      this.init(item, item1);
    },
    handleMultiSelect() {
      this.isMultiSelect = true;
      this.searchCondition[2].selectedValue = "";
      this.moreList = [];
      this.matBigClasses = "";
    },
    //多选点击事件
    clickMatBigClasses(item) {
      this.moreList.push({
        label: item.label,
        value: item.value
      });
      this.$set(item, "isShow", true);
    },
    //多选取消选中
    handleItemDel(item) {
      for (let i = 0; i < this.moreList.length; i++) {
        if (this.moreList[i].value === item.value) {
          this.moreList.splice(i, 1);
          break;
        }
      }
      this.$set(item, "isShow", false);
    },
    //多选确定
    handleConfirm() {
      this.pageNo = 1;
      console.log("init666");
      this.init();
    },
    //多选取消
    handleCancel() {
      this.searchCondition[2].options = JSON.parse(
        JSON.stringify(this.matBigClassesOptions)
      );
      this.searchCondition[2].selectedValue = "";
      this.isMultiSelect = false;
      this.moreList = [];
      this.pageNo = 1;
      console.log("init777");
      this.init();
    },
    //点击结束时间 排序
    handleSortOrder() {
      if (this.sortOrder === "" || this.sortOrder === "0") {
        this.sortOrder = "1";
      } else {
        this.sortOrder = "0";
      }
      this.pageNo = 1;
      console.log("init888");
      this.init();
    },
    typeClose() {
      this.searchCondition[0].selectedValues = [];
      this.searchCondition[0].selectedValue = "";
      this.searchCondition[0].selectedLabel = this.$t("page.content.all");

      this.noticeTime = [];
      this.searchCondition[1].selectedValue = "";
      this.searchCondition[1].selectedLabel = this.$t("page.content.all");

      this.moreList = [];
      this.searchCondition[2].selectedValue = "";
      this.searchCondition[2].selectedLabel = this.$t("page.content.all");
      // this.handleCancel();
    },
    //关闭 面包屑tag
    handleClose(num) {
      switch (num) {
        case 1: //采购方式
          this.searchCondition[0].selectedValues = [];
          this.searchCondition[0].selectedValue = "";
          this.searchCondition[0].selectedLabel = this.$t("page.content.all");
          break;
        case 2: //发布时间
          this.noticeTime = [];
          this.searchCondition[1].selectedValue = "";
          this.searchCondition[1].selectedLabel = this.$t("page.content.all");
          break;
        case 3: //物资分类
          this.moreList = [];
          this.searchCondition[2].selectedValue = "";
          this.searchCondition[2].selectedLabel = this.$t("page.content.all");
          this.handleCancel();
          break;
      }
      this.pageNo = 1;
      console.log("init999");
      this.init();
    },
    changeRecent(value) {
      let endTime = moment(new Date()).format("YYYY-MM-DD");
      let startTime = moment(
        new Date().getTime() - Number(value) * 1000 * 24 * 60 * 60
      ).format("YYYY-MM-DD");
      return [startTime, endTime];
    },
    formatMoreList(list) {
      let l = list.map(item => item.label);
      return l.join(",");
    },
    getList(isPage) {
      console.log("init1000");
      this.init(isPage);
    },
    handlePrev() {
      --this.pageNo;
      this.getList("pageclick");
    },
    handleNext() {
      ++this.pageNo;
      this.getList("pageclick");
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      if (val !== "none") {
        this.pageSize = val;
      }
      // let obj = {
      //   pageNo: this.pageNo,
      //   pageSize: this.pageSize
      // };
      // this.getList(obj);
      this.getList("pageclick");
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      // let obj = {
      //   pageNo: this.pageNo,
      //   pageSize: this.page
      // };
      // this.getList(obj);
      this.getList("pageclick");
    }
  },
  computed: {
    languagezh_cn() {
      return ('en-gb') === "zh-cn";
    },
    isShow() {
      return item => {
        if (!item.isShow) {
          return {
            display: "none"
          };
        } else {
          return {
            display: "inline-block"
          };
        }
      };
    },
    isActive() {
      return (item, item1) => {
        if (!item.selectedValues || item.selectedValues.length === 0) {
          if (item.selectedValue === item1.value) {
            return "table-top-active";
          } else {
            return "table-top";
          }
        } else {
          let obj = item.selectedValues.filter(i => {
            return i.value === item1.value;
          });
          if (obj.length > 0) {
            return "table-top-active";
          } else {
            return "table-top";
          }
        }
      };
    }
  },
  watch: {
    // $route(to, from) {
    //   if (to.name === "searchList") {
    //     console.log('init10111')
    //     this.init();
    //   }
    // },
    isMultiSelect(val) {
      if (val) {
        this.searchCondition[2].options.shift();
      }
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ .ccui-app-container-detail {
  padding-top: 0;
}
/deep/ .el-button.el-button--table-top-active {
  border: none;
}
.moreFold {
  height: 50px;
  overflow: hidden;
}
.drop-btn {
  position: relative;
}
.el-icon-arrow-down {
  //position: absolute;
  top: 19px;
  right: 15px;
}
.dropDown {
  height: 100px;
  position: relative;
}
.isShow-position {
  .el-icon-arrow-down {
    position: absolute;
  }
}
.dropContent {
  display: flex;
  position: absolute;
  top: 30px;
  left: 0px;
  margin-top: 20px;
}
.dropAll {
  font-weight: 600;
  font-size: 13px;
  color: #0089ef;
  margin-right: 30px;
  padding: 10px 0;
  border: none;
  padding-left: 0;
  padding-right: 0;
  background: #fff !important;
}
.dropAllNull {
  font-weight: 500;
  font-size: 13px;
  color: #4a4a4a !important;
  border: none;
  padding-left: 0;
  padding-right: 0;
  background: #fff !important;
}
.drop-text {
  color: #4a4a4a;
  font-weight: 500;
  font-size: 13px;
  margin-right: 30px;
  padding: 10px 0;
}
.search-condition {
  background-color: #fff;
  margin-top: 10px;
  margin-bottom: 20px;
}
.condition {
  min-height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #e9e9e9;
  display: flex;
}
.conditionCn {
  min-height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #e9e9e9;
  display: flex;
}
.conditionEn {
  min-height: 100px;
  line-height: 50px;
  border-bottom: 1px solid #e9e9e9;
  display: flex;
}
.flex-1Cn {
  flex: 1;
}
.flex-1En {
  flex-wrap: wrap;
  justify-content: left;
  align-content: flex-start;
  div:nth-child(6) {
    //width: 150px;
  }
}
.position_En {
  width: 150px;
}
.condition-left {
  min-width: 108px;
}
.condition-leftCn {
  min-width: 108px;
}
.condition-leftEn {
  min-width: 169px;
}
.condition-type {
  color: #666666;
  font-size: 13px;
}
/deep/ .ccui-multifunctional-table-wrapper .ccui-table-footer {
  padding-top: 0;
  padding-bottom: 20px;
}
.condition /deep/ .el-button {
  margin-right: 30px;
  margin-left: 0;
}
.condition em {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 8px;
}
.activeBlack {
  color: #999999;
}
.active {
  color: #0089ef;
}
.el-icon-caret-bottom {
  margin-top: -5px;
}
.dis-flex {
  display: flex;
}
.flex-1 {
  flex: 1;
}
.page-em {
  padding-right: 20px;
  padding-left: 10px;
  font-size: 14px;
}
.hiddenHeight {
  height: 50px;
  overflow: hidden;
}
.more-and-more {
  margin-right: 20px;
  font-size: 13px;
  color: #4a4a4a;
}
.chooseActive {
  .button-show {
    border: 1px solid #0089ef;
    position: relative;
    width: 135px;
    color: #0089ef;
    display: inline-block;
    text-align: left;
    padding-left: 12px;
    margin-right: 0;
  }
  b {
    background-color: #0089ef;
    color: #ffffff;
    width: 30px;
    display: inline-block;
    line-height: 34px;
    text-align: center;
    margin-right: 10px;
    padding-top: 1px;
  }
}
.notice-warning-text {
  display: none;
  vertical-align: super;
}
.btn-options /deep/ .is-disabled {
  color: #cccccc;
  :hover {
    .notice-warning-outline {
      color: #d50a0c;
    }
    .notice-warning-text {
      color: #d50a0c;
      display: inline-block;
    }
  }
}
.notice-warning-outline {
  font-size: 14px;
  vertical-align: super;
}
.empty-content {
  line-height: 320px;
}
/deep/.el-table__body {
  tr {
    .cell {
      height: 30px;
      line-height: 30px;
    }
  }
}
/deep/ .el-table {
  tr th,
  tr td {
    border-right: none;
  }
}
.search {
  margin-top: 10px;
  width: 644px;
  height: 32px;
  line-height: 32px;
  .search-input {
    width: 524px;
  }
  /deep/.el-input__inner {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }
  .search-btn {
    width: 60px;
    /*background: #0089ef;*/
    border: 1px solid #ccc;
    color: #0089ef;
    height: 30px;
    line-height: 6px;
    margin-right: -2px;
    margin-top: 1px;
    /*margin-left: 2px;*/
    border-radius: 2px;
    border-end-start-radius: 0;
    border-start-start-radius: 0;
  }
}
.paginationEn {
  /deep/ .el-pagination .el-select .el-input {
    width: 125px !important;
  }
}
</style>
